import { snakeCase, toUpperCase } from 'string-ts';

export const toScreamingSnakeCase = <TString extends string>(input: TString) => {
  return toUpperCase(snakeCase(input));
};
